function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "\uF2FC");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  fillOpacity: 0,
  fontFamily: "Ionicons",
  fontSize: 30,
  fontWeight: 400
}, React.createElement("g", {
  id: "Product-Detail-Page---Reviews",
  transform: "translate(-356.000000, -1050.000000)",
  fill: "#000000",
  stroke: "#000000"
}, React.createElement("g", {
  id: "Information-Section",
  transform: "translate(63.000000, 905.000000)"
}, React.createElement("g", {
  id: "Content",
  transform: "translate(0.000000, 73.000000)"
}, React.createElement("g", {
  id: "Write-a-Review",
  transform: "translate(42.000000, 27.000000)"
}, React.createElement("g", {
  id: "Your-Rating",
  transform: "translate(0.000000, 42.000000)"
}, React.createElement("g", {
  id: "Rating-Stars",
  transform: "translate(131.000000, 0.000000)"
}, React.createElement("text", {
  id: "\\uF2FC"
}, React.createElement("tspan", {
  x: 120,
  y: 26
}, "\uF2FC")))))))));

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.d150103b.svg";
export { ForwardRef as ReactComponent };